import messages from './exchange-rate-results-lang.json';
import getPosition from '../../../common/js/get-position/get-position';
import moment from 'moment';
import { DISPLAY_DATE_FORMAT, BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';

const desktopHeaders = {
	exchange: [
		'unitSize',
		'middleRate',
		'currencyBuyingRate',
		'currencySellingRate',
		'chequeBuyingRate',
		'chequeSellingRate',
		'foreignExchangeBuyingRate',
		'foreignExchangeSellingRate'
	],
	MNB: ['unitSize', 'middleRate'],
	foreign: ['unitSize', 'middleRate', 'foreignExchangeBuyingRate', 'foreignExchangeSellingRate']
};
const mobileHeaders = {
	exchange: [
		'middleRate',
		'currencyBuyingRate',
		'currencySellingRate',
		'chequeBuyingRate',
		'chequeSellingRate',
		'foreignExchangeBuyingRate',
		'foreignExchangeSellingRate'
	],
	MNB: ['middleRate'],
	foreign: ['middleRate', 'foreignExchangeBuyingRate', 'foreignExchangeSellingRate']
};
export default {
	data() {
		return {
			currentColumn: 0,
			stickyTop: false,
			stickyBottom: false
		};
	},
	props: {
		date: {
			required: true
		},
		messages: {
			required: true
		},
		type: {
			type: String,
			required: true,
			validator(value) {
				return value == 'exchange' || value == 'MNB' || value == 'foreign';
			}
		},
		results: {
			required: true
		},
		foreignType: {
			required: false
		}
	},
	i18n: { messages },
	computed: {
		headers() {
			return this.isMobile ? mobileHeaders : desktopHeaders;
		},
		isMNB() {
			return this.type == 'MNB';
		},
		isForeign() {
			return this.type == 'foreign';
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		concatTableCaption() {
			let rateType;
			let ratesA11Y = this.$t('ratesA11Y');
			if (this.isForeign) {
				let foreignA11Y = this.$t('foreignA11Y');
				rateType = foreignA11Y + ' ' + ratesA11Y;
			} else if (this.isMNB) {
				rateType = this.$t('mnbA11Y') + ' ' + ratesA11Y;
			} else {
				rateType = this.$t('hufA11Y') + ' ' + ratesA11Y;
			}
			return rateType + ' ' + moment(this.date, BACKEND_DATE_FORMAT).format(DISPLAY_DATE_FORMAT[this.$i18n.locale]) + ' ' + this.results.time;
		}
	},
	methods: {
		onScroll() {
			if (this.$refs.results) {
				let scrollTop = getPosition(this.$refs.results).y;
				let tableHeight = document.getElementById('rate_data').offsetHeight;
				this.stickyTop = scrollTop < 0 && scrollTop + tableHeight > 80;
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll);
	}
};
